module.exports = __webpack_public_path__ + "media/auto_history/pierwsza_rejestracja-c7acccf2.svg";